<template lang="pug">
  section.ranking.ranking-interior
    h3
      span Tiempos del rally nacional
      small presentado por
        img(src="content/logo-citroen.png")
    .no
      h4 Próxima Fecha:
        strong 20 y 21 de Octubre

</template>
<script>
import {mapState, mapActions} from 'vuex'
import Row from '@/components/Row'
import PrimeSelector from '@/components/PrimeSelector'
import TimeSelector from '@/components/TimeSelector'

export default {
  components: {

  },
}
</script>
<style lang="scss" scoped>
  .ranking-interior{
    padding: 5px;
  }
  h3{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4rem 0;
    font-weight: 900;
    font-style: italic;
    text-transform: uppercase;
    span{
      font-size: 1.2rem;
    }
    small{
      font-size: 1rem;
      display: flex;
      align-items: center;
      img{
        max-height: 40px;
      }
    }
  }
  h1{
    font-weight: bold;
    text-align: center;
    color: lighten(black, 50%);
  }
  .cols{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    @media (max-width: 900px){
      grid-template-columns: repeat(1, 1fr);
    }
    .col{
      overflow: hidden;
      padding: 0.5rem;
    }
  }
  .title{
    border-bottom: 1px solid #c0c0c0;
  }
  .data{
    .wraprow{
      &:nth-child(odd){
        background-color: lighten(black, 70%);
      }
    }
  }

  .wraprow{
    padding: 2px;
    display: grid;
    grid-template-columns: 7% 7% 45% repeat(3, 1fr);
    align-items: center;
    .col{
      font-size: 14px;
      line-height: 14px;
      padding: 0;
      margin: 0;
      text-align: center;
    }
  }
  .no{
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 400px;

    h4{
      font-size: 2rem;
    }
    strong{
      display: block;
    }
  }

</style>


